'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  margin: auto;\n  padding: 16px;\n  padding-top: 24px;\n  max-width: 1050px;\n\n  font-family: Roboto, Arial, sans-serif;\n\n  @media (', ') {\n    padding-top: 16px;\n  }\n\n  code {\n    background-color: ', ';\n  }\n\n  pre {\n    padding: 12px;\n    overflow: auto;\n    background-color: ', ';\n\n    > code {\n      background: none;\n    }\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    margin-top: 0.8em;\n    margin-bottom: 0.3em;\n    font-weight: 400;\n\n    &:first-child {\n      margin-top: 8px;\n    }\n  }\n  h1 {\n    font-size: 45px;\n  }\n  h2 {\n    font-size: 34px;\n  }\n  h3 {\n    font-size: 24px;\n  }\n  h4 {\n    font-size: 20px;\n    font-weight: 500;\n  }\n  h5 {\n    font-size: 16px;\n  }\n  h6 {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  ul {\n    padding-left: 32px;\n\n    > li {\n      padding-top: 8px;\n\n      > p {\n        display: inline;\n      }\n    }\n  }\n\n  p {\n    max-width: 600px;\n    overflow: auto;\n  }\n\n  strong {\n    font-weight: 500;\n  }\n'], ['\n  margin: auto;\n  padding: 16px;\n  padding-top: 24px;\n  max-width: 1050px;\n\n  font-family: Roboto, Arial, sans-serif;\n\n  @media (', ') {\n    padding-top: 16px;\n  }\n\n  code {\n    background-color: ', ';\n  }\n\n  pre {\n    padding: 12px;\n    overflow: auto;\n    background-color: ', ';\n\n    > code {\n      background: none;\n    }\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    margin-top: 0.8em;\n    margin-bottom: 0.3em;\n    font-weight: 400;\n\n    &:first-child {\n      margin-top: 8px;\n    }\n  }\n  h1 {\n    font-size: 45px;\n  }\n  h2 {\n    font-size: 34px;\n  }\n  h3 {\n    font-size: 24px;\n  }\n  h4 {\n    font-size: 20px;\n    font-weight: 500;\n  }\n  h5 {\n    font-size: 16px;\n  }\n  h6 {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  ul {\n    padding-left: 32px;\n\n    > li {\n      padding-top: 8px;\n\n      > p {\n        display: inline;\n      }\n    }\n  }\n\n  p {\n    max-width: 600px;\n    overflow: auto;\n  }\n\n  strong {\n    font-weight: 500;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  height: 100%;\n'], ['\n  display: flex;\n  height: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 16px;\n\n  color: white;\n  border-bottom: ', ';\n\n  text-decoration: none;\n\n  &:focus:not(:active) {\n    background-color: ', ';\n    outline: none;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 16px;\n\n  color: white;\n  border-bottom: ', ';\n\n  text-decoration: none;\n\n  &:focus:not(:active) {\n    background-color: ', ';\n    outline: none;\n  }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactCssThemr = require('react-css-themr');

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _reactRouterDom = require('react-router-dom');

var _Redirect = require('react-router/Redirect');

var _Redirect2 = _interopRequireDefault(_Redirect);

var _Route = require('react-router/Route');

var _Route2 = _interopRequireDefault(_Route);

var _app_bar = require('react-toolbox/lib/app_bar');

require('react-toolbox/lib/commons.scss');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('styled-material/dist/src/colors');

var _routes = require('../lib/routes');

var _styles = require('../styles');

var _theme = require('../theme');

var _folderPage = require('./pages/folder-page');

var _modulePage = require('./pages/module-page');

var _singlePage = require('./pages/single-page');

var _routerLink = require('./router-link');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Main = _styledComponents2.default.main(_templateObject, _styles.mobile, _colors.materialColors['grey-100'], _colors.materialColors['grey-100']);
var Nav = _styledComponents2.default.nav(_templateObject2);
var NavLink = (0, _styledComponents2.default)(_reactRouterDom.Link)(_templateObject3, function (_ref) {
  var active = _ref.active;
  return active ? '2px solid ' + _colors.materialColors['pink-a400'] : 'none';
}, _colors.materialColors['indigo-400']);
var App = exports.App = function App(_ref2) {
  var title = _ref2.title,
      pages = _ref2.pages,
      apiDocs = _ref2.apiDocs;

  var routes = (0, _routes.buildRoutes)(pages, apiDocs);
  return React.createElement(_reactCssThemr.ThemeProvider, { theme: _theme.theme }, React.createElement(_reactRouterDom.HashRouter, null, React.createElement("div", null, React.createElement(_reactDocumentTitle2.default, { title: title }), React.createElement(_app_bar.AppBar, { title: title }, React.createElement(Nav, null, routes.map(function (_ref3) {
    var url = _ref3.url,
        title = _ref3.title;
    return title && React.createElement(_routerLink.RouterLink, { key: url, exact: url === '/', component: NavLink, to: url }, title);
  }))), React.createElement(Main, null, routes.map(function (route) {
    return React.createElement(_Route2.default, { key: route.url, exact: route.url === '/asd', path: route.url, render: function render() {
        return route.kind === 'folder' ? React.createElement(_folderPage.FolderPage, { page: route, appTitle: title }) : route.kind === 'page' ? React.createElement(_singlePage.SinglePage, { page: route, appTitle: title }) : route.kind === 'module' ? React.createElement(_modulePage.ModuleRoutes, { page: route, appTitle: title }) : React.createElement(_Redirect2.default, { to: route.to });
      } });
  })))));
};
//# sourceMappingURL=app.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/components/app.js